<template>
  <form ref="form" method="post">
    <input type="hidden" name="_token" :value="csrfToken" />
    <div class="l-page l-page--message-edit-condition">
      <main class="l-main">
        <!-- パンくずリスト -->
        <breadcrumb :breadcrumb-data="breadcrumbData" />
        <!-- /パンくずリスト -->

        <div class="l-main-head">
          <div class="c-title u-w420">
            <div class="c-title__text c-title__text--blue u-fs34">配信メッセージの新規作成</div>
          </div>
          <div class="c-progress">
            <ul class="c-progress-list">
              <li class="c-progress-list__item">メッセージの作成</li>
              <li class="c-progress-list__item is-current">配信条件の設定</li>
              <li class="c-progress-list__item">配信内容の確認</li>
              <li class="c-progress-list__item">設定完了</li>
            </ul>
          </div>
        </div>
        <div class="l-main-content">
          <div class="p-message-edit p-message-edit--delivery-segment-group">
            <div class="c-title">
              <div class="c-title__text u-fs24">配信条件を選ぶ</div>
            </div>
            <div class="p-message-edit-list p-message-edit-list--first">
              <div class="p-message-edit-list__item">
                <div class="c-select-card">
                  <ul class="c-select-card-list">
                    <li class="c-select-card-list__item">
                      <label class="c-select-card__label">
                        <input
                          v-model="conditionType"
                          type="radio"
                          name="delivery_condition_type"
                          value="1"
                        />
                        <div class="c-select-card__item">
                          <div class="c-icon-circle c-icon-circle--purple u-wh80">
                            <div class="c-icon-circle__item c-icon-circle__item--white u-wh44">
                              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <use xlink:href="/assets/img/sprite.svg#segment-user" />
                              </svg>
                            </div>
                          </div>
                          <div class="c-select-card-content">
                            <div class="c-select-card-content__title">セグメント配信</div>
                            <div class="c-select-card-content__text">指定ページへの訪問ユーザーや端末・OSなど</div>
                            <div class="c-select-card-content__text">絞りこんだ配信を行います</div>
                          </div>
                        </div>
                      </label>
                    </li>
                    <li class="c-select-card-list__item">
                      <label class="c-select-card__label">
                        <input
                          v-model="conditionType"
                          type="radio"
                          name="delivery_condition_type"
                          value="2"
                        />
                        <div class="c-select-card__item">
                          <div class="c-icon-circle c-icon-circle--orange u-wh80">
                            <div class="c-icon-circle__item c-icon-circle__item--white u-wh44">
                              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <use xlink:href="/assets/img/sprite.svg#all-user" />
                              </svg>
                            </div>
                          </div>
                          <div class="c-select-card-content">
                            <div class="c-select-card-content__title">
                              全配信<span class="c-select-card-content__title--recommended">始めたばかりの方におすすめ！</span>
                            </div>
                            <div class="c-select-card-content__text">すべてのオプトインに配信を行います</div>
                          </div>
                        </div>
                      </label>
                    </li>
                  </ul>
                  <div class="c-error c-error--balloon">
                    <div class="c-error__text"></div>
                  </div>
                </div>
              </div>
              <div v-show="conditionType != 2" class="p-message-edit-condition-select-block">
                <div class="c-title">
                  <div class="c-title__text">セグメントの接続タイプ</div>
                </div>
                <div class="p-message-edit-list__item">
                  <div class="c-radio u-w100p">
                    <ul class="c-radio-list">
                      <li class="c-radio-list__item">
                        <label class="c-radio__label u-w300">
                          <input
                            v-model="conditionJoinType"
                            type="radio"
                            name="condition_join_type"
                            value="AND"
                          />
                          <div class="c-radio__item">
                            <div class="c-radio__box"></div>
                            <div class="c-radio__box-label">かつ(AND) </div>
                          </div>
                        </label>
                      </li>
                      <li class="c-radio-list__item u-w300">
                        <label class="c-radio__label">
                          <input
                            v-model="conditionJoinType"
                            type="radio"
                            name="condition_join_type"
                            value="OR"
                          />
                          <div class="c-radio__item">
                            <div class="c-radio__box"></div>
                            <div class="c-radio__box-label">または(OR)</div>
                          </div>
                        </label>
                      </li>
                      <li class="c-radio-list__item u-w300">
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <message-select-condition
                v-show="conditionType != 2"
                ref="messageSelectCondition"
                :is-enable-topic-condition="isEnableTopicCondition"
                :is-enable-hybrid-condition="isEnableHybridCondition"
                :width="456"
                :base-conditions="conditionInfo.conditions"
                :base-condition-source-types="conditionInfo.conditionSourceTypes"
                :topic-conditions="conditionInfo.topicConditions"
                :on-select="onSelectConditionChange"
                :initial-data="{ baseConditions: message.message_conditions, topicConditions: message.topic_message_condition ? [message.topic_message_condition] : [] }"
              />

            </div>
          </div>
        </div>
      </main>
    </div>
    <div class="p-message-predict p-message-predict--no-number">
      <div class="p-message-predict__content">
        <div class="p-message-predict-suspend">
          <div class="p-message-predict-suspend__items">
            <button
              class="c-btn c-btn--block u-w146 u-fs24"
              type="button"
              name="destroy"
              value="destroy"
              @click="onQuitClick"
            >
              <p class="c-btn__text">作成をやめる</p>
            </button>
          </div>
          <!-- <div class="p-message-predict-suspend__items">
                    <button class="c-btn c-btn--block u-w96 u-fs24" type="button" name="save" value="save" v-on:click="onSaveClick">
                        <p class="c-btn__text">保存する</p>
                    </button>
                </div> -->
        </div>
        <div class="p-message-predict__btns">
          <button
            class="c-btn c-btn--gray u-w320 u-h50 u-fs20"
            type="button"
            name="prev"
            value="prev"
            @click="onBackClick()"
          >
            <p class="c-btn__text">メッセージ作成に戻る</p>
          </button>
          <button
            class="c-btn c-btn--blue u-w320 u-h50 u-fs20"
            :class="{ 'is-loading': isLoadingConfirmBtn }"
            :disabled="isLoadingConfirmBtn"
            type="button"
            name="next"
            value="next"
            @click="onConfirmClick()"
          >
            <p class="c-btn__text">内容の確認画面へ</p>
          </button>
        </div>
      </div>
    </div>
    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />
  </form>
</template>

<script>
export default {
  props: {
    isEnableTopicCondition: Boolean,
    isEnableHybridCondition: Boolean,
    breadcrumbData: Array,
    conditionInfo: Object,
    csrfToken: String,
    message: Object,
  },
  data() {
    return {
      conditionType: null,
      isSegment: false,
      createType: null,
      selectedConditionId: null,
      isLoading: false,
      conditionName: null,
      conditionDetailList: [],
      conditionDetailKey: null,
      conditionJoinType:  this.message.condition_join_type || 'AND',
      genders: [],
      ages: [],
      regions: [],
      prefectures: [],
      interest: null,
      keyword: null,
      allValue: '9999',
      errorMessage: '',
      isError: false,
      isLoadingConfirmBtn: false,
      params: {
        conditions: [],
        topicConditions: [],
      },
    }
  },
  mounted: function () {
    import('../../funcs/pages/message-add-condition').then(module => {
      module.MessageAddCondition();
    });
    import('../../funcs/components/select').then(module => {
      module.Select();
    });

    this.conditionDetailList = [];

    // 各KeyのConditionDetailを１個ずつ作成しておく
    Object.keys(this.conditionInfo.conditionKeyTypes).map(conditionKey => {
      this.conditionDetailList[conditionKey] = [];
      this.conditionDetailList[conditionKey].push({
        value: '',
        operator: 'eq'
      });
    });

    // 初期選択値の設定
    this.params = {
      conditions: (this.message.message_conditions && Array.isArray(this.message.message_conditions) && this.message.message_conditions.length > 0)
        ? this.message.message_conditions.map((item) => item.condition_id)
        : [],
      topicConditions: this.message.topic_message_condition
        ? [this.message.topic_message_condition.topic_condition_id]
        : [],
    }

    let hasCondition = false;
    if((this.message.message_conditions && Array.isArray(this.message.message_conditions) && this.message.message_conditions.length > 0)){
      hasCondition = true;
    }

    if(this.message.topic_message_condition){
      hasCondition = true;
    }

    if(hasCondition){
      this.conditionType = 1;
    } else {
      this.conditionType = 2;
    }
  },
  methods: {
    appendForm(params,name,value){
      // null/undefinedの場合のみスキップ、空文字列や0は送信する
      if(value !== null && value !== undefined){
        params.append(name,value);
      }
    },
    onQuitClick: function () {
      location.href = this.conditionInfo.listUrl;
    },
    onBackClick: function () {
      location.href = this.conditionInfo.editUrl + '?type=edit&message_id=' + this.message.message_id;
    },
    onConfirmClick: function () {
      if (this.conditionType == 1) {

        // 配信条件を1つ以上選択していない場合はエラーメッセージを表示
        if (this.params.conditions.length < 1 && this.params.topicConditions.length < 1) {
          this.$refs.messageSelectCondition.setErrorBaseCondition('1つ以上の配信条件を選択してください')
          this.$refs.messageSelectCondition.setErrorTopicCondition('1つ以上の配信条件を選択してください')
          return;
        }

        // 選択した配信条件のIDをクエリパラメーターに変換
        const queryParameter = {
          conditions: (0 < this.params.conditions.length)
            ? `condition_ids[]=${this.params.conditions.join('&condition_ids[]=')}`
            : '',
          // 属性条件が有効ではない場合は、仮に選択値があっても使用しない
          topicConditions: (0 < this.params.topicConditions.length && this.isEnableTopicCondition)
            ? `topic_condition_ids[]=${this.params.topicConditions.join('&topic_condition_ids[]=')}`
            : '',
          all  : '',
        }

        // 各条件の選択値を元に完全なクエリパラメーター文字列を整形
        if (queryParameter.conditions != '' && queryParameter.topicConditions != '') {
          queryParameter.all = `${queryParameter.conditions}&${queryParameter.topicConditions}`;
        } else if (queryParameter.conditions != '' && queryParameter.topicConditions == '') {
          queryParameter.all = queryParameter.conditions;
        } else if (queryParameter.conditions == '' && queryParameter.topicConditions != '') {
          queryParameter.all = queryParameter.topicConditions;
        }

        // 作成したクエリパラメーターを指定して確認画面に遷移
        location.href = this.conditionInfo.confirmUrl + '?message_id=' + this.message.message_id + '&' + queryParameter.all + '&condition_join_type=' + this.conditionJoinType;

      } else if (this.conditionType == 2) {
        // 全配信の場合は、何も処理せず、確認画面へ遷移
        location.href = this.conditionInfo.confirmUrl + '?message_id=' + this.message.message_id;
      } else {
        // セグメント配信か？全配信か？を未選択の場合は、エラーメッセージを表示
        this.showErrors({
          'delivery_condition_type': '配信条件を選択してください'
        });
      }
      /*
            this.$refs.form.action = this.addConditionConfirmUrl;
            this.$refs.form.submit();
            event.preventDefault();
            */
    },
    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
    onSelectRegionListItemChange: function(regions, prefectures) {
      this.regions = regions;
      this.prefectures = prefectures;
    },
    onSelectConditionChange: function(baseConditions, topicConditions) {
      this.params.conditions = baseConditions
        .filter((item) => item.id)
        .map((item) => item.id);
      this.params.topicConditions = topicConditions
        .filter((item) => item.id)
        .map((item) => item.id);
    }
  }
}
</script>
